// extracted by mini-css-extract-plugin
module.exports = {"checkboxSVG":"_1r7KO","checkboxSvg":"_1r7KO","checkbox-container":"_1dpkf","checkboxContainer":"_1dpkf"};